import { isAxiosError } from "axios";
import { postUser } from "@/apis/user/route";
import { TermsAgreementType } from "@/apis/user/types";
import { updateUserPassword } from "@/services/auth-service";

export type ActivateAccountResult =
  | { status: "success" }
  | { status: "password-error"; message: string }
  | { status: "registration-error" };

interface ActivateAccountParams {
  newPassword: string;
  agreements: TermsAgreementType[];
  /** 이전 시도에서 같은 비밀번호가 이미 설정됐으면 Firebase 재호출을 건너뛴다. */
  passwordAlreadySet?: boolean;
  updatePassword?: typeof updateUserPassword;
  registerUser?: typeof postUser;
}

export const activateAccount = async ({
  newPassword,
  agreements,
  passwordAlreadySet = false,
  updatePassword = updateUserPassword,
  registerUser = postUser,
}: ActivateAccountParams): Promise<ActivateAccountResult> => {
  if (!passwordAlreadySet) {
    const result = await updatePassword(newPassword);
    if (!result.success) {
      return {
        status: "password-error",
        message: result.error ?? "비밀번호 설정에 실패했습니다.",
      };
    }
  }

  try {
    await registerUser(agreements);
  } catch (error) {
    // 409는 이전 시도에서 가입까지 끝났다는 뜻이므로 활성화 완료로 간주한다.
    if (!isAxiosError(error) || error.response?.status !== 409) {
      return { status: "registration-error" };
    }
  }

  return { status: "success" };
};
